import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserAuthenticationService } from './../../services/user-authentication.service';


@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css']
})
export class OtpComponent implements OnInit {
	@Input() token;
	@Input() message;
	@Input() otpId;
	@Output() passEntry: EventEmitter<any> = new EventEmitter();
	
	errorMessage:string;
	
	codes:string[] = ["","","","",""];
	
	
	
	constructor(public activeModal: NgbActiveModal,private uAService:UserAuthenticationService) { }

	ngOnInit() {
		
		
	}
	
	
	onKey(event: any) { 
		let element = event.srcElement.nextElementSibling; 
		if(element == null)  
			return;
		else
			element.focus();
	}
	
	submitOtp(){
		
		this.uAService.verifyOtp({otp_id:this.otpId,code:this.codes.join("")}).subscribe(
			data => {
				console.log(data);	
				var jsonData = <any>data;
				this.errorMessage = "";
				if(jsonData.hasOwnProperty('result') && jsonData.result){
					if(jsonData.result){
						this.passEntry.emit(true);
						this.activeModal.dismiss();
					}else{
						this.passEntry.emit(false);
					}
				}
				if(jsonData.hasOwnProperty('message')){
					this.errorMessage = jsonData.message;
				}
			},
			error => {
				console.log(error);
				var jsonData = <any>error;
				if(jsonData.hasOwnProperty('message')){
					this.errorMessage = jsonData.message;
				}
				
			}
		);
	}
	
	resendOtp(){
		
		this.uAService.resendOtp({otp_id:this.otpId}).subscribe(
			data => {
				console.log(data);	
				var jsonData = <any>data;
				this.errorMessage = "";
				if(jsonData.hasOwnProperty('result') && jsonData.result){
					if(jsonData.result){
						this.passEntry.emit(true);
						this.activeModal.dismiss();
					}else{
						this.passEntry.emit(false);
					}
				}
				if(jsonData.hasOwnProperty('message')){
					this.errorMessage = jsonData.message;
				}
			},
			error => {
				console.log(error);
				var jsonData = <any>error;
				if(jsonData.hasOwnProperty('message')){
					this.errorMessage = jsonData.message;
				}
				
			}
		);
	}
	
	closeOtp(){
		
		this.activeModal.dismiss();
	}

}
